import Vue from 'vue'
import VueRouter from 'vue-router'

import Build from '@/views/Build.vue'
import Podcasts from '@/views/Podcasts'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            name: 'Redirect',
            path: '/',
            component: {
                render: h => h('div'),
                mounted() {
                    window.location = `https://${window.location.origin.endsWith('.unify.ws') ? 'launcher.unify.ws' : 'launcher.unify.fun'}?returnUrl=${window.location.origin}`
                },
            },
            meta: { requiresAuth: true },
        },
        {
            path: '/:buildKey',
            component: Build,
            meta: { requiresAuth: true },
            children: [{ name: 'Podcasts', path: '', component: Podcasts, props: true }],
        },
    ],
})

export default router
